// Sales.js
import React, { useState, useEffect, useCallback } from 'react';
import { salesApi, inventoryApi, staffApi } from '../api/client';
import { Badge, Modal, CID, Spin, Empty, useFlash, F, parseErr, MultiSelect } from '../components/UI';
import { Printer } from '../components/Icons';
import { useAuth } from '../context/AuthContext';
import CustomerSearch from '../components/CustomerSearch';

export default function Sales() {
  const { canWrite } = useAuth();
  const [rows, setRows] = useState([]); const [busy, setBusy] = useState(true);
  const [showAdd, setAdd] = useState(false); const [bill, setBill] = useState(null);
  const { show, Flash } = useFlash();
  const [prods, setProds] = useState([]);
  const [staff, setStaff] = useState([]);
  const [form, setForm] = useState({ customer_id:'',product_id:'',qty:1,serial_number_id:'',payment_mode:'Cash',payment_status:'paid',amount_paid:'',followup_date:'',assigned_to:[] });
  const [discVal, setDiscVal] = useState('');
  const [cFound, setCF] = useState(null);
  const [saving, setSaving] = useState(false); const [err, setErr] = useState('');
  const [q, setQ] = useState('');
  const [viewSale, setViewSale] = useState(null);
  const [view, setView]         = useState('list');
  const [calMonth, setCalMonth] = useState(() => { const d = new Date(); return { year: d.getFullYear(), month: d.getMonth() }; });
  const [selDay, setSelDay]     = useState(null);
  const set = k => e => setForm(f=>({...f,[k]:e.target.value}));

  const load = useCallback(async()=>{ setBusy(true); try { const {data}=await salesApi.list(); setRows(data); } finally { setBusy(false); } },[]);

  const printBill = (sale, invNum) => {
    const discAmt = Number(sale.subtotal) * Number(sale.discount || 0) / 100;
    const isExchange = sale.notes && sale.notes.toLowerCase().includes('exchange');
    const itemRows = (sale.items || []).map((item, i) => {
      const wm = item.product?.warranty_months || 0;
      const warrantyTag = wm > 0 ? ` <span style="font-size:10px;color:#2563eb">(${wm} months Warranty)</span>` : '';
      const snTag = item.serial_number ? `<br/><span style="font-size:10.5px;color:#888">S/N: ${item.serial_number}</span>` : '';
      return `<tr>
        <td style="padding:7px 10px;color:#666;text-align:center">${i+1}</td>
        <td style="padding:7px 10px">${item.product?.name || item.product_name || '—'}${warrantyTag}${snTag}</td>
        <td style="padding:7px 10px;text-align:center;color:#666">${item.product?.hsn_code || '8541'}</td>
        <td style="padding:7px 10px;text-align:center">${item.qty}</td>
        <td style="padding:7px 10px;text-align:right">&#8377;${Number(item.unit_price).toLocaleString('en-IN')}</td>
        <td style="padding:7px 10px;text-align:right;font-weight:600">&#8377;${Number(item.qty*item.unit_price).toLocaleString('en-IN')}</td>
      </tr>`;
    }).join('');
    const discRow = discAmt > 0 ? `
      <tr><td colspan="2" style="text-align:right;padding:4px 6px;color:green;font-size:12px">${isExchange ? 'Under Exchange' : 'Discount'}</td>
      <td style="text-align:right;padding:4px 6px;color:green;font-size:12px">&#8722; &#8377;${discAmt.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}</td></tr>` : '';
    const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>Invoice ${invNum}</title>
    <style>
      @page { size: A4; margin: 15mm; }
      * { box-sizing: border-box; margin: 0; padding: 0; }
      body { font-family: Arial, sans-serif; font-size: 13px; color: #111; }
      .header { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #1e3a5f; padding-bottom: 12px; margin-bottom: 16px; }
      .company-name { font-size: 18px; font-weight: 700; color: #1e3a5f; margin-bottom: 4px; }
      .company-info { font-size: 11px; color: #666; line-height: 1.6; }
      .inv-label { font-size: 15px; font-weight: 700; color: #1e3a5f; letter-spacing: 2px; text-align: right; }
      .inv-meta { font-size: 11px; color: #666; text-align: right; margin-top: 4px; line-height: 1.7; }
      .bill-to { background: #f5f7fa; border-radius: 6px; padding: 10px 14px; margin-bottom: 14px; font-size: 12px; }
      .bill-to-label { font-weight: 700; color: #1e3a5f; margin-bottom: 4px; }
      table { width: 100%; border-collapse: collapse; margin-bottom: 14px; font-size: 12px; }
      thead tr { background: #1e3a5f; color: #fff; }
      thead th { padding: 8px 10px; text-align: left; }
      tbody tr { border-bottom: 1px solid #e5e7eb; }
      .totals-table { width: 260px; margin-left: auto; font-size: 12px; }
      .totals-table td { padding: 4px 6px; }
      .grand-total td { font-size: 15px; font-weight: 700; color: #1e3a5f; border-top: 2px solid #1e3a5f; padding-top: 8px; }
      .payment-row { font-size: 12px; margin-top: 14px; display: flex; gap: 24px; }
      .footer { margin-top: 24px; padding-top: 10px; border-top: 1px solid #e5e7eb; font-size: 11px; color: #888; text-align: center; }
    </style></head><body>
    <div class="header">
      <div>
        <div class="company-name">Sakthi Solar Solutions</div>
        <div class="company-info">
          Sakthi Arcade, Market Jn, Kandiyoor, Thattarambalam PO, Mavelikara - 690103<br/>
          Ph: 9446191276, 9846065984, 0479 2305650, 2309650<br/>
          Email: info@sakthiinverters.com &nbsp;|&nbsp; www.sakthiinverters.com
        </div>
      </div>
      <div>
        <div class="inv-label">INVOICE</div>
        <div class="inv-meta">
          Invoice No: <strong>${invNum}</strong><br/>
          Date: ${new Date(sale.created_at).toLocaleDateString('en-IN',{dateStyle:'medium'})}
        </div>
      </div>
    </div>
    ${sale.customer ? `<div class="bill-to">
      <div class="bill-to-label">Bill To:</div>
      <div style="font-weight:600">${sale.customer.full_name}</div>
      ${sale.customer.customer_code ? `<div style="color:#666">Customer ID: ${sale.customer.customer_code}</div>` : ''}
      ${sale.customer.phone ? `<div style="color:#666">Ph: ${sale.customer.phone}</div>` : ''}
      ${sale.customer.address ? `<div style="color:#666">${sale.customer.address}</div>` : ''}
    </div>` : ''}
    <table>
      <thead><tr>
        <th style="width:36px;text-align:center">#</th>
        <th>Product / Description</th>
        <th style="width:60px;text-align:center">HSN</th>
        <th style="width:50px;text-align:center">Qty</th>
        <th style="width:90px;text-align:right">Unit Price</th>
        <th style="width:90px;text-align:right">Amount</th>
      </tr></thead>
      <tbody>${itemRows}</tbody>
    </table>
    <table class="totals-table">
      <tbody>
        <tr><td style="color:#666">Subtotal</td><td style="text-align:right">&#8377;${Number(sale.subtotal).toLocaleString('en-IN')}</td></tr>
        ${discRow}
        <tr class="grand-total"><td>Total</td><td style="text-align:right">&#8377;${Number(sale.total).toLocaleString('en-IN')}</td></tr>
      </tbody>
    </table>
    <div class="payment-row">
      <span><strong>Payment Mode:</strong> ${sale.payment_mode || '—'}</span>
      <span><strong>Status:</strong> ${sale.payment_status}</span>
    </div>
    <div class="footer">
      Thank you for your business! &nbsp;|&nbsp; This is a computer-generated invoice.<br/>
      <span style="font-size:9px;color:#bbb">Developed by Data Systems Intelligence Pvt Ltd</span>
    </div>
    </body></html>`;
    const w = window.open('', '_blank', 'width=850,height=1100');
    w.document.write(html);
    w.document.close();
    w.onload = () => { w.focus(); w.print(); };
  };
  useEffect(()=>{ load(); inventoryApi.list().then(({data})=>setProds(data)).catch(()=>{}); staffApi.list().then(({data})=>setStaff(data)).catch(()=>{}); },[load]);
  const selProd = prods.find(p=>p.id===form.product_id);

  const save = async () => {
    if(!form.customer_id||!form.product_id) { setErr('Customer and product required.'); return; }
    setSaving(true); setErr('');
    try {
      const subtotal = Number(selProd.mrp) * parseInt(form.qty || 1);
      const discPct  = discVal && subtotal > 0 ? (Number(discVal) / subtotal) * 100 : 0;
      const saleItem = {product_id:form.product_id,qty:parseInt(form.qty),unit_price:selProd.mrp,discount:0};
      if (form.serial_number_id) saleItem.serial_number_id = form.serial_number_id;
      const payload = { customer_id:form.customer_id, items:[saleItem], discount:discPct, notes: discPct > 0 ? 'Under Exchange' : undefined, payment_mode:form.payment_mode, payment_status:form.payment_status, assigned_to: form.assigned_to.length > 0 ? form.assigned_to : undefined };
      if (form.amount_paid !== '') payload.amount_paid = Number(form.amount_paid);
      if (form.followup_date) payload.followup_date = form.followup_date;
      const {data}=await salesApi.create(payload);
      // Persist customer + payment info locally so Payment FUPs page can display them
      if (form.payment_status === 'partial' || form.payment_status === 'pending') {
        try {
          const ls = JSON.parse(localStorage.getItem('sakthi_fup') || '{}');
          ls[data.id] = {
            customer_name:  cFound?.full_name || '',
            customer_phone: cFound?.phone || '',
            amount_paid:    form.amount_paid !== '' ? Number(form.amount_paid) : 0,
            followup_date:  form.followup_date || null,
          };
          localStorage.setItem('sakthi_fup', JSON.stringify(ls));
        } catch {}
      }
      setRows(r=>[data,...r]); show('Sale recorded!'); setAdd(false);
      setForm({customer_id:'',product_id:'',qty:1,serial_number_id:'',payment_mode:'Cash',payment_status:'paid',amount_paid:'',followup_date:'',assigned_to:[]}); setDiscVal(''); setCF(null);
    } catch(e){ setErr(parseErr(e, 'Failed to record sale.')); } finally { setSaving(false); }
  };

  if (busy) return <Spin/>;
  return (
    <div>
      <Flash/>
      <div className="page-hd"><h2>Sales & Billing</h2>{canWrite&&<button className="btn btn-primary" onClick={()=>setAdd(true)}>+ New Sale</button>}</div>
      <div className="search-row">
        <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Search by customer name…"/>
      </div>
      <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12}}>
        <div className="stat-grid" style={{gridTemplateColumns:'repeat(3,1fr)', flex:1, margin:0}}>
          <div className="stat-card"><div className="stat-lbl">Total Sales</div><div className="stat-val">{rows.length}</div></div>
          <div className="stat-card"><div className="stat-lbl">Fully Paid</div><div className="stat-val" style={{color:'var(--green)'}}>{rows.filter(s=>s.payment_status==='paid').length}</div></div>
          <div className="stat-card"><div className="stat-lbl">Part / Pending</div><div className="stat-val" style={{color:'var(--red)'}}>{rows.filter(s=>s.payment_status==='partial'||s.payment_status==='pending').length}</div></div>
        </div>
        <div style={{display:'flex', gap:4, marginLeft:12}}>
          {[['list','List'],['calendar','Calendar']].map(([v,lbl])=>(
            <button key={v} onClick={()=>setView(v)} className={`btn btn-sm${view===v?' btn-primary':''}`}>{lbl}</button>
          ))}
        </div>
      </div>

      {/* ── List view ── */}
      {view==='list' && (
        <div className="card card-0">
          {rows.length===0 ? <Empty msg="No sales recorded yet"/> : (
            <div className="tbl-wrap"><table>
              <thead><tr><th>Date</th><th>Customer</th><th>Total</th><th>Payment</th><th>Status</th><th>Actions</th></tr></thead>
              <tbody>
                {rows.filter(s=>!q||((s.customer?.full_name||'').toLowerCase().includes(q.toLowerCase()))).map(s=>(
                  <tr key={s.id} style={{cursor:'pointer'}} onClick={()=>setViewSale(s)}>
                    <td style={{fontSize:12}}>{new Date(s.created_at).toLocaleDateString('en-IN')}</td>
                    <td style={{fontSize:12}}>{s.customer?.full_name || '—'}</td>
                    <td style={{fontWeight:600}}>₹{Number(s.total).toLocaleString('en-IN')}</td>
                    <td>{s.payment_mode}</td>
                    <td><Badge label={s.payment_status}/></td>
                    <td onClick={e=>e.stopPropagation()}>
                      <button className="btn btn-sm" onClick={()=>setBill(s)}><Printer s={13}/> View Bill</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table></div>
          )}
        </div>
      )}

      {/* ── Calendar view ── */}
      {view==='calendar' && (() => {
        const {year, month} = calMonth;
        const firstDay = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month+1, 0).getDate();
        const todayStr = new Date().toISOString().split('T')[0];

        const byDay = {};
        rows.forEach(s => {
          const d = s.created_at?.split('T')[0];
          if (d) { if (!byDay[d]) byDay[d] = []; byDay[d].push(s); }
        });

        const cells = [];
        for (let i=0; i<firstDay; i++) cells.push(null);
        for (let d=1; d<=daysInMonth; d++) cells.push(d);

        const dayNames = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
        const monthLabel = new Date(year, month).toLocaleDateString('en-IN', {month:'long', year:'numeric'});
        const prevMonth = () => setCalMonth(({year:y,month:m}) => m===0?{year:y-1,month:11}:{year:y,month:m-1});
        const nextMonth = () => setCalMonth(({year:y,month:m}) => m===11?{year:y+1,month:0}:{year:y,month:m+1});
        const selComplaints = selDay ? (byDay[selDay]||[]) : [];

        return (
          <div style={{display:'grid', gridTemplateColumns: selDay?'1fr 300px':'1fr', gap:16, alignItems:'start'}}>
            <div className="card" style={{padding:0, overflow:'hidden'}}>
              <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 20px', borderBottom:'1px solid var(--border)'}}>
                <button className="btn btn-sm btn-ghost" onClick={prevMonth} style={{padding:'4px 10px'}}>‹</button>
                <span style={{fontWeight:700, fontSize:15, color:'var(--navy)'}}>{monthLabel}</span>
                <button className="btn btn-sm btn-ghost" onClick={nextMonth} style={{padding:'4px 10px'}}>›</button>
              </div>
              <div style={{display:'grid', gridTemplateColumns:'repeat(7,1fr)', borderBottom:'1px solid var(--border)'}}>
                {dayNames.map(d=>(
                  <div key={d} style={{textAlign:'center', padding:'8px 0', fontSize:11, fontWeight:700, color:'var(--text2)', textTransform:'uppercase'}}>{d}</div>
                ))}
              </div>
              <div style={{display:'grid', gridTemplateColumns:'repeat(7,1fr)'}}>
                {cells.map((day, idx) => {
                  if (!day) return <div key={`e${idx}`}/>;
                  const dateStr = `${year}-${String(month+1).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
                  const daySales = byDay[dateStr] || [];
                  const dayTotal = daySales.reduce((sum,s)=>sum+Number(s.total),0);
                  const isToday = dateStr===todayStr;
                  const isSel   = dateStr===selDay;
                  return (
                    <div key={dateStr} onClick={()=>setSelDay(isSel?null:dateStr)}
                      style={{minHeight:72, padding:'8px 6px', borderRight:'1px solid var(--border)', borderBottom:'1px solid var(--border)',
                        cursor: daySales.length?'pointer':'default',
                        background: isSel?'rgba(59,130,246,.08)':'transparent', transition:'background .1s'}}>
                      <div style={{width:26, height:26, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center',
                        fontSize:13, fontWeight: isToday?700:400,
                        background: isToday?'var(--blue)':'transparent',
                        color: isToday?'#fff':'var(--text)', marginBottom:4}}>{day}</div>
                      {daySales.length>0 && (
                        <div>
                          <div style={{fontSize:10, fontWeight:700, color:'var(--green)'}}>₹{dayTotal.toLocaleString('en-IN')}</div>
                          <div style={{fontSize:10, color:'var(--text2)'}}>{daySales.length} sale{daySales.length>1?'s':''}</div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            {selDay && (
              <div className="card" style={{padding:0, overflow:'hidden'}}>
                <div style={{padding:'12px 16px', borderBottom:'1px solid var(--border)', display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                  <span style={{fontWeight:700, fontSize:13, color:'var(--navy)'}}>
                    {new Date(selDay+'T00:00:00').toLocaleDateString('en-IN',{dateStyle:'long'})}
                  </span>
                  <button className="btn btn-sm btn-ghost" style={{padding:'2px 6px'}} onClick={()=>setSelDay(null)}>✕</button>
                </div>
                {selComplaints.length===0
                  ? <div style={{padding:20, fontSize:13, color:'var(--text2)'}}>No sales on this date.</div>
                  : <div style={{display:'flex', flexDirection:'column'}}>
                      {selComplaints.map((s,i)=>(
                        <div key={s.id} onClick={()=>setViewSale(s)}
                          style={{padding:'12px 16px', borderBottom: i<selComplaints.length-1?'1px solid var(--border)':'none', cursor:'pointer'}}>
                          <div style={{display:'flex', justifyContent:'space-between', marginBottom:3}}>
                            <span style={{fontWeight:700, color:'var(--navy)'}}>₹{Number(s.total).toLocaleString('en-IN')}</span>
                            <Badge label={s.payment_status}/>
                          </div>
                          <div style={{fontSize:12}}>{s.customer?.full_name||'—'}</div>
                          <div style={{fontSize:11, color:'var(--text2)'}}>{s.payment_mode}</div>
                        </div>
                      ))}
                    </div>
                }
              </div>
            )}
          </div>
        );
      })()}

      <Modal open={showAdd} onClose={()=>{ setAdd(false); setDiscVal(''); setForm({customer_id:'',product_id:'',qty:1,serial_number_id:'',payment_mode:'Cash',payment_status:'paid',amount_paid:'',followup_date:'',assigned_to:[]}); setCF(null); }} title="New Sale"
        footer={<><button className="btn" onClick={()=>{ setAdd(false); setDiscVal(''); setForm({customer_id:'',product_id:'',qty:1,serial_number_id:'',payment_mode:'Cash',payment_status:'paid',amount_paid:'',followup_date:'',assigned_to:[]}); setCF(null); }}>Cancel</button><button className="btn btn-primary" onClick={save} disabled={saving}>{saving?'Saving…':'Save & Generate Bill'}</button></>}
      >
        {err && <div className="notice n-err" style={{marginBottom:10}}>{err}</div>}
        {!form.customer_id
          ? <div style={{marginBottom:12}}><CustomerSearch onSelect={c => { setCF(c); setForm(f=>({...f,customer_id:c.id})); }} placeholder="Search customer by name / ID / phone…"/></div>
          : <div className="notice n-ok" style={{marginBottom:12,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <span><strong>{cFound?.full_name}</strong> <CID code={cFound?.customer_code}/></span>
              <button className="btn btn-sm btn-ghost" style={{padding:'2px 8px'}} onClick={() => { setCF(null); setForm(f=>({...f,customer_id:''})); }}>Change</button>
            </div>
        }
        <div className="fg-2">
          <F label="Product" full>
            <select value={form.product_id} onChange={e=>setForm(f=>({...f,product_id:e.target.value,serial_number_id:''}))}>
              <option value="">-- Select Product --</option>
              {prods.map(p=><option key={p.id} value={p.id}>{p.name} — ₹{Number(p.mrp).toLocaleString('en-IN')} (Stock: {p.stock_qty})</option>)}
            </select>
          </F>
          {selProd && selProd.stock_qty === 0 && (
            <div style={{gridColumn:'1/-1',padding:'8px 12px',background:'#fff3cd',border:'1px solid #ffc107',borderRadius:6,fontSize:12,color:'#856404',fontWeight:500}}>
              Out of Stock — this product has no inventory available.
            </div>
          )}
          {selProd && (() => {
            const inStock = (selProd.serials || []).filter(s => s.status === 'in_stock');
            return inStock.length > 0 ? (
              <F label="Serial Number" full>
                <select value={form.serial_number_id} onChange={set('serial_number_id')}>
                  <option value="">-- Select Serial Number (optional) --</option>
                  {inStock.map(s => <option key={s.id} value={s.id}>{s.serial_number}</option>)}
                </select>
              </F>
            ) : (
              <div style={{gridColumn:'1/-1',padding:'7px 10px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:6,fontSize:12,color:'var(--text2)'}}>
                No serial numbers tracked for this product. Add serials via Inventory to enable tracking.
              </div>
            );
          })()}
          <F label="Quantity"><input type="number" min="1" value={form.qty} onChange={set('qty')}/></F>

          {/* Discount */}
          <div style={{gridColumn:'1/-1', padding:'10px 12px', background:'var(--surface)', borderRadius:8, border:'1px solid var(--border)'}}>
            <div style={{fontSize:12, fontWeight:600, color:'var(--text2)', textTransform:'uppercase', marginBottom:8}}>Under Exchange Discount (optional)</div>
            <div style={{display:'flex', alignItems:'center', gap:8}}>
              <span style={{padding:'5px 14px', fontSize:13, fontWeight:600, borderRadius:6, background:'var(--primary)', color:'#fff', whiteSpace:'nowrap'}}>₹ Fixed</span>
              <input type="number" min="0" step="0.01" value={discVal}
                onChange={e=>setDiscVal(e.target.value)} placeholder="0.00" style={{width:120}}/>
              {discVal > 0 && <span style={{fontSize:12, color:'var(--green)', fontWeight:600}}>
                − ₹{Number(discVal).toLocaleString('en-IN')} off
              </span>}
            </div>
          </div>

          {/* Price summary */}
          {selProd && (() => {
            const subtotal   = Number(selProd.mrp) * (parseInt(form.qty) || 1);
            const discAmt    = discVal ? Math.min(Number(discVal), subtotal) : 0;
            const grandTotal = subtotal - discAmt;
            return (
              <div style={{gridColumn:'1/-1', padding:'10px 14px', background:'var(--surface)', borderRadius:8, fontSize:13}}>
                <div style={{display:'flex', justifyContent:'space-between', marginBottom:3, color:'var(--text2)'}}><span>Subtotal</span><span>₹{subtotal.toLocaleString('en-IN')}</span></div>
                {discAmt > 0 && <div style={{display:'flex', justifyContent:'space-between', marginBottom:3, color:'var(--green)'}}><span>Under Exchange</span><span>− ₹{discAmt.toLocaleString('en-IN',{maximumFractionDigits:2})}</span></div>}
                <div style={{display:'flex', justifyContent:'space-between', fontWeight:700, borderTop:'1px solid var(--border)', paddingTop:4, marginTop:4, color:'var(--navy)'}}><span>Total</span><span>₹{grandTotal.toLocaleString('en-IN',{maximumFractionDigits:2})}</span></div>
              </div>
            );
          })()}

          <F label="Assigned To" full>
            <MultiSelect
              options={staff.filter(s=>s.is_active && s.role === 'field').map(s=>({ value: s.id, label: s.name }))}
              value={form.assigned_to}
              onChange={ids => setForm(f=>({...f, assigned_to: ids}))}
            />
          </F>

          <F label="Payment Mode"><select value={form.payment_mode} onChange={set('payment_mode')}>{['Cash','Card','UPI','Bank Transfer'].map(m=><option key={m}>{m}</option>)}</select></F>
          <F label="Payment Received">
            <select value={form.payment_status} onChange={set('payment_status')}>
              <option value="paid">Full Payment Received</option>
              <option value="partial">Part Payment</option>
              <option value="pending">Not Yet Paid</option>
            </select>
          </F>
          {form.payment_status === 'partial' && (
            <>
              <F label="Amount Paid Now (₹)">
                <input type="number" min="0" placeholder="Amount received so far"
                  value={form.amount_paid} onChange={set('amount_paid')}/>
              </F>
              <F label="Follow-up Date">
                <input type="date" value={form.followup_date} onChange={set('followup_date')}/>
              </F>
            </>
          )}
        </div>
      </Modal>

      {/* ── Sale Detail Modal ── */}
      <Modal open={!!viewSale} onClose={()=>setViewSale(null)} title="Sale Details"
        footer={<>
          <button className="btn" onClick={()=>setViewSale(null)}>Close</button>
          <button className="btn btn-primary" onClick={()=>{ const n=rows.length-rows.findIndex(r=>r.id===viewSale.id); printBill(viewSale,`INV-${String(n).padStart(4,'0')}`); }}><Printer s={13}/> Print Bill</button>
        </>}
      >
        {viewSale && (() => {
          const discAmt = Number(viewSale.subtotal) * Number(viewSale.discount || 0) / 100;
          const isExchange = viewSale.notes && viewSale.notes.toLowerCase().includes('exchange');
          return (
            <div style={{fontSize:13}}>
              {/* Customer */}
              {viewSale.customer && (
                <div style={{background:'var(--surface)', borderRadius:8, padding:'10px 14px', marginBottom:14}}>
                  <div style={{fontWeight:700, color:'var(--navy)', marginBottom:2}}>{viewSale.customer.full_name}</div>
                  {viewSale.customer.customer_code && <div style={{fontSize:12, color:'var(--text2)'}}>ID: {viewSale.customer.customer_code}</div>}
                  {viewSale.customer.phone && <div style={{fontSize:12, color:'var(--text2)'}}>{viewSale.customer.phone}</div>}
                  {viewSale.customer.address && <div style={{fontSize:12, color:'var(--text2)'}}>{viewSale.customer.address}</div>}
                </div>
              )}
              {/* Date */}
              <div style={{display:'flex', gap:12, padding:'8px 0', borderBottom:'1px solid var(--border)'}}>
                <span style={{minWidth:130, fontWeight:600, fontSize:12, color:'var(--text2)'}}>Date &amp; Time</span>
                <span>{new Date(viewSale.created_at).toLocaleString('en-IN',{dateStyle:'medium',timeStyle:'short'})}</span>
              </div>
              {/* Items */}
              {viewSale.items && viewSale.items.length > 0 && (
                <div style={{margin:'12px 0'}}>
                  <div style={{fontWeight:600, fontSize:12, color:'var(--text2)', marginBottom:6, textTransform:'uppercase', letterSpacing:'0.4px'}}>Items</div>
                  {viewSale.items.map((item, i) => (
                    <div key={i} style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', padding:'8px 0', borderBottom:'1px solid var(--border)'}}>
                      <div>
                        <div style={{fontWeight:500}}>{item.product?.name || item.product_name || '—'}</div>
                        {item.serial_number && <div style={{fontSize:11, color:'var(--text2)'}}>S/N: {item.serial_number}</div>}
                        <div style={{fontSize:11, color:'var(--text2)'}}>Qty {item.qty} × ₹{Number(item.unit_price).toLocaleString('en-IN')}</div>
                      </div>
                      <span style={{fontWeight:600, color:'var(--navy)', whiteSpace:'nowrap', marginLeft:12}}>₹{Number(item.qty*item.unit_price).toLocaleString('en-IN')}</span>
                    </div>
                  ))}
                </div>
              )}
              {/* Totals */}
              <div style={{marginBottom:12}}>
                <div style={{display:'flex', justifyContent:'space-between', padding:'5px 0', fontSize:12, color:'var(--text2)'}}>
                  <span>Subtotal</span><span>₹{Number(viewSale.subtotal).toLocaleString('en-IN')}</span>
                </div>
                {discAmt > 0 && (
                  <div style={{display:'flex', justifyContent:'space-between', padding:'5px 0', fontSize:12, color:'green'}}>
                    <span>{isExchange ? 'Under Exchange' : 'Discount'}</span>
                    <span>− ₹{discAmt.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                  </div>
                )}
                <div style={{display:'flex', justifyContent:'space-between', padding:'8px 0', borderTop:'2px solid var(--navy)', fontWeight:700, fontSize:15, color:'var(--navy)'}}>
                  <span>Total</span><span>₹{Number(viewSale.total).toLocaleString('en-IN')}</span>
                </div>
              </div>
              {/* Payment */}
              {[
                ['Payment Mode',   viewSale.payment_mode || '—'],
                ['Payment Status', null],
                ...(viewSale.amount_paid != null ? [['Amount Paid', `₹${Number(viewSale.amount_paid).toLocaleString('en-IN')}`]] : []),
                ...((viewSale.assigned_staff_names?.length > 0) ? [['Assigned To', viewSale.assigned_staff_names.join(', ')]] : []),
              ].map(([label, value]) => (
                <div key={label} style={{display:'flex', gap:12, padding:'8px 0', borderBottom:'1px solid var(--border)', fontSize:13}}>
                  <span style={{minWidth:130, fontWeight:600, fontSize:12, color:'var(--text2)'}}>{label}</span>
                  {label === 'Payment Status'
                    ? <Badge label={viewSale.payment_status}/>
                    : <span>{value}</span>
                  }
                </div>
              ))}
            </div>
          );
        })()}
      </Modal>

      <Modal open={!!bill} onClose={()=>setBill(null)} title="Invoice"
        footer={<><button className="btn" onClick={()=>setBill(null)}>Close</button><button className="btn btn-primary" onClick={()=>{ const n=rows.length-rows.findIndex(r=>r.id===bill.id); printBill(bill,`INV-${String(n).padStart(4,'0')}`); }}><Printer s={14}/> Print Bill</button></>}
      >
        {bill && (() => {
          const invNum = `INV-${String(rows.length - rows.findIndex(r=>r.id===bill.id)).padStart(4,'0')}`;
          return (
          <div style={{fontSize:13,color:'#111'}}>
            {/* Header */}
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:14,paddingBottom:12,borderBottom:'2px solid var(--navy)'}}>
              <div>
                <div style={{fontSize:17,fontWeight:700,color:'var(--navy)'}}>Sakthi Solar Solutions</div>
                <div style={{fontSize:11.5,color:'var(--text2)',marginTop:3}}>Sakthi Arcade, Market Jn, Kandiyoor, Thattarambalam PO, Mavelikara - 690103</div>
                <div style={{fontSize:11.5,color:'var(--text2)'}}>Ph: 9446191276, 9846065984, 0479 2305650, 2309650</div>
                <div style={{fontSize:11.5,color:'var(--text2)'}}>Email: info@sakthiinverters.com | www.sakthiinverters.com</div>
              </div>
              <div style={{textAlign:'right'}}>
                <div style={{fontSize:13,fontWeight:700,color:'var(--navy)',letterSpacing:1}}>INVOICE</div>
                <div style={{fontSize:11.5,color:'var(--text2)',marginTop:4}}>Invoice No: <strong>{invNum}</strong></div>
                <div style={{fontSize:11.5,color:'var(--text2)'}}>Date: {new Date(bill.created_at).toLocaleDateString('en-IN',{dateStyle:'medium'})}</div>
              </div>
            </div>

            {/* Bill To */}
            {bill.customer && (
              <div style={{background:'var(--surface)',borderRadius:6,padding:'8px 12px',marginBottom:12,fontSize:12}}>
                <div style={{fontWeight:600,marginBottom:4,color:'var(--navy)'}}>Bill To:</div>
                <div style={{fontWeight:500}}>{bill.customer.full_name}</div>
                {bill.customer.customer_code && <div style={{color:'var(--text2)'}}>Customer ID: {bill.customer.customer_code}</div>}
                {bill.customer.phone && <div style={{color:'var(--text2)'}}>Ph: {bill.customer.phone}</div>}
                {bill.customer.address && <div style={{color:'var(--text2)'}}>{bill.customer.address}</div>}
              </div>
            )}

            {/* Items Table */}
            {bill.items && bill.items.length > 0 && (
              <table style={{width:'100%',borderCollapse:'collapse',marginBottom:12,fontSize:12}}>
                <thead>
                  <tr style={{background:'var(--navy)',color:'#fff'}}>
                    <th style={{padding:'6px 8px',textAlign:'left'}}>#</th>
                    <th style={{padding:'6px 8px',textAlign:'left'}}>Product / Description</th>
                    <th style={{padding:'6px 8px',textAlign:'center'}}>HSN</th>
                    <th style={{padding:'6px 8px',textAlign:'center'}}>Qty</th>
                    <th style={{padding:'6px 8px',textAlign:'right'}}>Unit Price</th>
                    <th style={{padding:'6px 8px',textAlign:'right'}}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {bill.items.map((item,i)=>(
                    <tr key={i} style={{borderBottom:'1px solid var(--border)'}}>
                      <td style={{padding:'6px 8px',color:'var(--text2)'}}>{i+1}</td>
                      <td style={{padding:'6px 8px'}}>
                        {item.product?.name || item.product_name || '—'}
                        {item.serial_number && <div style={{fontSize:10.5,color:'var(--text2)'}}>S/N: {item.serial_number}</div>}
                      </td>
                      <td style={{padding:'6px 8px',textAlign:'center',color:'var(--text2)'}}>{item.product?.hsn_code || '8541'}</td>
                      <td style={{padding:'6px 8px',textAlign:'center'}}>{item.qty}</td>
                      <td style={{padding:'6px 8px',textAlign:'right'}}>₹{Number(item.unit_price).toLocaleString('en-IN')}</td>
                      <td style={{padding:'6px 8px',textAlign:'right',fontWeight:500}}>₹{Number(item.qty*item.unit_price).toLocaleString('en-IN')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {/* Totals */}
            {(() => {
              const discAmt = Number(bill.subtotal) * Number(bill.discount || 0) / 100;
              const isExchange = bill.notes && bill.notes.toLowerCase().includes('exchange');
              return (
                <div style={{marginLeft:'auto',maxWidth:280,borderTop:'1px solid var(--border)',paddingTop:8,marginBottom:12}}>
                  <div style={{display:'flex',justifyContent:'space-between',fontSize:12,color:'var(--text2)',marginBottom:4}}><span>Subtotal</span><span>₹{Number(bill.subtotal).toLocaleString('en-IN')}</span></div>
                  {discAmt > 0 && (
                    <div style={{display:'flex',justifyContent:'space-between',fontSize:12,color:'green',marginBottom:4}}>
                      <span>{isExchange ? 'Under Exchange' : 'Discount'}</span>
                      <span>− ₹{discAmt.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                    </div>
                  )}
                  <div style={{display:'flex',justifyContent:'space-between',fontSize:15,fontWeight:700,color:'var(--navy)',marginTop:8,paddingTop:8,borderTop:'2px solid var(--navy)'}}><span>Total</span><span>₹{Number(bill.total).toLocaleString('en-IN')}</span></div>
                </div>
              );
            })()}

            {/* Payment */}
            <div style={{fontSize:12,display:'flex',gap:20,flexWrap:'wrap'}}>
              <span><strong>Payment Mode:</strong> {bill.payment_mode}</span>
              <span style={{display:'flex',alignItems:'center',gap:6}}><strong>Status:</strong> <Badge label={bill.payment_status}/></span>
            </div>

            {/* Footer */}
            <div style={{marginTop:16,paddingTop:10,borderTop:'1px solid var(--border)',fontSize:11,color:'var(--text2)',textAlign:'center'}}>
              Thank you for your business! &nbsp;|&nbsp; This is a computer-generated invoice.
            </div>
          </div>
          );
        })()}
      </Modal>
    </div>
  );
}
